import { useApi } from "@/hooks/use-api";
import { useAppState } from "@/store/useApp";
import { useEffect, useState } from "react";

export const PdfViewer = () => {
  const { loadPdf } = useApi();
  const [src, setSrc] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const currentDocument = useAppState((state) => state.currentDocument);

  useEffect(() => {
    let isMounted = true;
    let blobUrl: string | null = null;
    setLoading(true);
    setSrc(null);
    loadPdf(currentDocument!.id)
      .then((url) => {
        if (isMounted) {
          setSrc(url);
          blobUrl = url;
        }
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });
    return () => {
      isMounted = false;
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
      }
    };
  }, [currentDocument, loadPdf]);

  if (loading) {
    return <div className="w-full h-full flex items-center justify-center">Loading PDF...</div>;
  }
  if (!src) return null;
  return (
    <div className="w-full h-full flex items-center justify-center bg-gray-50">
      <iframe
        src={src}
        title="PDF Document"
        className="w-full h-full min-h-[80vh] border-none rounded shadow"
        style={{ minHeight: "80vh" }}
        allowFullScreen
      />
    </div>
  );
}; 